const awsConfig = {
  // API Gateway
  apiGateway: {
    URL: 'https://e013qa0r6h.execute-api.ap-northeast-1.amazonaws.com/dev',
    region: 'ap-northeast-1'
  },
  
  // Cognito
  cognito: {
    region: 'ap-northeast-1',
    userPoolId: 'ap-northeast-1_2t1cvodNF',
    userPoolWebClientId: '4ueu1j10lojmkdbdt4f2drv3aq'
  }
};

export default awsConfig; 